import api from "../../api/api";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const save_content_template_thunk = async (data) =>
  await api.post(`saveMasterTchTrainingContent`, data);
export const update_content_template_thunk = async (data) =>
  await api.put(`updateMasterTchTrainingContent`, data);

export const save_media = createAsyncThunk("media/create", async (body) => {
  console.log("-->body: ", body);
  let response = await api.post("save_media", body);
  return response.data;
});
